import { AppLogoHeader } from 'templates/AppLogoHeader';
import { PageContent } from 'templates/PageContent';
import { Form } from 'templates/Form';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { AppFooter } from 'templates/AppFooter';

export const GroupApplicationCompletion = () => {
  const { t: tAuditionForm } = useTranslationWithLang('auditionForm');
  return (
    <>
      <AppLogoHeader />
      <PageContent>
        <Form title={tAuditionForm('TU002_109')}>
          <div className={'min-h-[20vh] flex flex-col text-center items-center justify-center'}>
            <div className={'text-center text-lg'}>
              <p>{tAuditionForm('TU002_110')}</p>
            </div>
          </div>
        </Form>
      </PageContent>
      <AppFooter />
    </>
  );
};
